<template>
    <ul class="horizontal-list text-center">
        <li :class="{active: $route.path.match(/about$/)}"><router-link to="/about">概要</router-link></li>
        <li :class="{active: $route.path.match(/write/)}"><router-link to="/about/write">小説を書く</router-link></li>
        <li :class="{active: $route.path.match(/read/)}"><router-link to="/about/read">小説を読む</router-link></li>
        <li :class="{active: $route.path.match(/instruction/)}"><router-link to="/about/instruction">ユーザー登録から執筆までの流れ</router-link></li>
    </ul>
</template>